/**
 * The one look for every portal upsell button: a purple-to-pink gradient, never the lime brand fill.
 * Locked content sits behind a blurred placeholder card with one of these buttons on it.
 */
export const UPSELL_GRADIENT_BG = 'linear-gradient(105deg,#4F2BE0,#A21CAF 55%,#DB2777)';

export const upsellClass =
  'bg-[linear-gradient(105deg,#4F2BE0,#A21CAF_55%,#DB2777)] text-white shadow-[0_14px_26px_-14px_rgba(162,28,175,0.7),inset_0_1px_0_rgba(255,255,255,0.28)] transition-[filter] hover:brightness-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2';

/** The soft lilac-to-pink panel behind a locked-content or credits block. */
export const upsellSurfaceClass =
  'border-[#EBDDFB] bg-[linear-gradient(135deg,#F4EEFF,#FFF0F7)] dark:border-fuchsia-500/25 dark:bg-[linear-gradient(135deg,rgba(79,43,224,0.18),rgba(219,39,119,0.12))]';

/** The icon tile on a locked block: white glyph on the same gradient as the button. */
export const upsellIconClass =
  'flex shrink-0 items-center justify-center bg-[linear-gradient(135deg,#4F2BE0,#DB2777)] text-white';

/**
 * Keeps a portal dialog inside a short or landscape phone: it never grows past the visible viewport (dvh follows
 * the iOS Safari toolbars), scrolls inside itself, and leaves a 12px margin at the sides.
 */
export const portalDialogFitClass = 'max-h-[calc(100dvh-1.5rem)] w-[calc(100vw-1.5rem)] overflow-y-auto overflow-x-hidden';

/** The dialog's close glyph is 16px; on a phone its hit area grows to 44px around it. */
export const portalDialogCloseClass = 'max-md:right-1.5 max-md:top-1.5 max-md:p-3.5';
